import { useCallback, useEffect, useRef, useState } from 'react'

const SHOW_COPIED_FOR = 2000

export function useCopied() {
  const [copied, setCopied] = useState(false)
  const timeout = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)

  useEffect(() => () => clearTimeout(timeout.current), [])

  const copy = useCallback((text: string) => {
    navigator.clipboard.writeText(text).catch(() => undefined)
    clearTimeout(timeout.current)
    setCopied(true)
    timeout.current = setTimeout(() => setCopied(false), SHOW_COPIED_FOR)
  }, [])

  return [copied, copy] as const
}
